
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCustomerSurveyTranDtGrid extends Serenity.EntityGrid<ReportCustomerSurveyTranDtRow, any> {
        protected getColumnsKey() { return ReportCustomerSurveyTranDtColumns.columnsKey; }
        protected getDialogType() { return ReportCustomerSurveyTranDtDialog; }
        protected getIdProperty() { return ReportCustomerSurveyTranDtRow.idProperty; }
        protected getInsertPermission() { return ReportCustomerSurveyTranDtRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportCustomerSurveyTranDtRow.localTextPrefix; }
        protected getService() { return ReportCustomerSurveyTranDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}